export default function showModal(modalName) {
    return {
        type: modalName
    };
}
